import React, { useState } from "react";
import Confetti from "react-confetti";
import { useWindowSize } from "react-use";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { Box, Typography } from "@mui/material";
import CakeIcon from "../components/icons/CakeIcon"; // Asegúrate de que la ruta y exportación estén correctas
import ConfettiCapIcon from "./icons/ConfettiCapIcon";
const BirthdayEffects = ({ name }) => {
  const { width, height } = useWindowSize();
  const [open, setOpen] = useState(true);

  return (
    <>
      <Confetti
        width={width}
        height={height}
        numberOfPieces={5000}
        recycle={false}
        gravity={0.1}
        tweenDuration={15000}
      />
      <Snackbar
        open={open}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "center", horizontal: "center" }}
        autoHideDuration={8000}
      >
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: "16px",
            boxShadow: 6,
            padding: 4,
            minWidth: 320,
            textAlign: "center",
          }}
        >
          <Typography
            variant='h2'
            fontWeight='bold'
            color='#801F56'
            gutterBottom
          >
            <ConfettiCapIcon width={60} /> ¡Feliz cumpleaños,{" "}
            {name || "usuario"}! <CakeIcon width={60} />
          </Typography>
          <Typography variant='h5' color='text.secondary'>
            Que tengas un día increíble lleno de alegría y sorpresas 🎈
          </Typography>
        </Box>
      </Snackbar>
    </>
  );
};

export default BirthdayEffects;
